import { render, staticRenderFns } from "./DetailSuratBpkb.vue?vue&type=template&id=02a3283e&"
import script from "./DetailSuratBpkb.vue?vue&type=script&lang=js&"
export * from "./DetailSuratBpkb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports